"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Stepper = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const tools_1 = require("../../tools");
const Box_1 = require("../Box");
const Stepper = ({ children, current, }) => {
    return (jsx_runtime_1.jsx(StyledBox, Object.assign({ marginY: "1.5rem", paddingY: "1.5px", textAlign: "center" }, { children: children.map((_, i) => (jsx_runtime_1.jsx(Box_1.Box, Object.assign({ display: "inline-block", width: "3rem", height: "3rem", lineHeight: "3rem", borderRadius: "1.5rem", fontSize: "1rem", color: i === current ? 'accentBackgroundedText' : 'primaryText', backgroundColor: i === current ? 'accent' : 'primary', textAlign: "center", fontFamily: "'Roboto'", marginY: "-1.5px", marginX: "0.25rem" }, { children: i + 1 }), i))) }), void 0));
};
exports.Stepper = Stepper;
const StyledBox = tools_1.styled(Box_1.Box) `
  &::before {
    display: block;
    height: 3px;
    background: #ccc;
    content: ' ';
    margin-top: 1.5rem;
    margin-bottom: -1.5rem;
  }
`;
//# sourceMappingURL=index.js.map